/**
 * CustomerResults.jsx
 * Created by Hassan Riaz on 1/16/20.
 */

import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../sharedComponents/Button/Button';

export default class CustomerResults extends React.PureComponent {
    static propTypes = {
        results: PropTypes.array,
        select: PropTypes.func
    };

    render() {
        const tableRows = this.props.results.map((account, i) => {
            const key = i
            return (
                <tr key={key}>
                    <td>
                        {account.first_name} {account.last_name}{' '}
                        {account.is_commercial_account && <div className="permit-text-less-emphasis">(Commercial user)</div>}
                    </td>
                    <td>{account.email}</td>
                    <td>{account.cell_phone}</td>
                    <td>
                        <Button
                            onClick={() => {
                                this.props.select(account.account_id)
                            }}>
                            Select
                        </Button>
                    </td>
                </tr>
            );
        });

        return (
            <div>
                <table>
                    <thead>
                        <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Phone</th>
                            <th scope="col">Select</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableRows}
                    </tbody>
                </table>
            </div>
        );
    }
}
